import { render, staticRenderFns } from "./marketing-appstore-notifications-index.vue?vue&type=template&id=b85b70b2&"
import script from "./marketing-appstore-notifications-index.vue?vue&type=script&lang=ts&"
export * from "./marketing-appstore-notifications-index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports